import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const submenuGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "or",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.MAIN_OBJECTIVE,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OBJECTIVES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const mainObjectiveGuards = {
  view: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.view,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.MAIN_OBJECTIVE,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  edit: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.manage,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.MAIN_OBJECTIVE,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  create: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.create,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.MAIN_OBJECTIVE,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
};

export const objectiveGuards = {
  view: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.view,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.OBJECTIVES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  edit: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.manage,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.OBJECTIVES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  create: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.create,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.OBJECTIVES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
};
